import(/* webpackMode: "eager", webpackExports: ["PlayerAvatar"] */ "/app/apps/web/src/components/common/image/player-avatar.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/player-profile/PlayerCollectionBreakdown/PlayerCollectionBreakdown.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/factionProfile/TopEventsHeaderItem/TopEventsRank/TopEventsRank.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/factionProfile/TopEventsHeaderItem/item.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/player-profile/PlayerDetails/PlayerDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/player-profile/PlayerFactionDetails/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/player-profile/PlayerTopEventFinishes/PlayerTopEventFinishes.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/player-profile/PlayerTopSuperstars/PlayerSuperstarCard/PlayerSuperstarCard.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/services/client/api-client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.25.3_next@15.5.18_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__r_2a2f0678776bbe3713c81e2fe0d56fd2/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/arccordion/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/carousel/carousel-arrow.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/responsive/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/features/leaderboard/leaderboard-row.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/icons/icomoon.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-bronze.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-gold.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-silver.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/subscription/add_club_coin_icon.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/subscription/club_coin_icon.webp");
